import { TableButtonEdit, TableButtonDelete } from "./tableButton";

/**
 * 薬剤管理画面用テーブル
 * @param props
 * @returns
 */
export default function ManagementTable<T>({
  title,
  datas,
  headers,
  onAdd,
  onEdit,
  onDelete,
  canEdit,
}: {
  title: string;
  datas?: T[];
  headers: { [key: string]: string };
  onAdd: () => void;
  onEdit: (data: T) => void;
  onDelete: (data: T) => void;
  canEdit: boolean;
}) {
  const ACTION_HEADERS = ["変更", "削除"];

  const keys = Object.keys(headers);
  return (
    <>
      {datas?.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th colSpan={keys.length}>{title}</th>
              {canEdit && <th colSpan={ACTION_HEADERS.length}>データ操作</th>}
            </tr>
            <tr>
              {keys.map(key => (
                <th key={`${title}-${key}`}>{headers[key]}</th>
              ))}
              {canEdit &&
                ACTION_HEADERS.map((header, index) => (
                  <th key={`${title}-act-${index}`}>{header}</th>
                ))}
            </tr>
          </thead>
          <tbody>
            {datas.map((v, index) => (
              <tr key={`${title}-item-${index}`}>
                {keys.map(k => (
                  <td>{v[k]}</td>
                ))}
                {canEdit && (
                  <td>
                    <TableButtonEdit onClick={() => canEdit && onEdit(v)} />
                  </td>
                )}
                {canEdit && (
                  <td>
                    <TableButtonDelete onClick={() => canEdit && onDelete(v)} />
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>登録されているデータがありません。</p>
      )}
      {canEdit && (
        <div className="parts">
          <button onClick={() => canEdit && onAdd()} className="positive">
            追加登録
          </button>
        </div>
      )}
    </>
  );
}
